/* eslint-disable object-curly-newline */
import update from 'immutability-helper';
import naturalCompare from 'string-natural-compare';
import { indexById } from '../indexById/indexById';
import { get as getId } from '../localId/localId';

export const ADD_LOCAL_EQUIPMENT_CATEGORY = 'ADD_LOCAL_EQUIPMENT_CATEGORY';
export const REMOVE_LOCAL_EQUIPMENT_CATEGORY = 'REMOVE_LOCAL_EQUIPMENT_CATEGORY';
export const API_LOAD_EQUIPMENT_CATEGORIES = 'API_LOAD_EQUIPMENT_CATEGORIES';
export const API_REMOVE_EQUIPMENT_CATEGORY = 'API_REMOVE_EQUIPMENT_CATEGORY';
export const API_CREATE_EQUIPMENT_CATEGORY = 'API_CREATE_EQUIPMENT_CATEGORY';
export const API_UPDATE_EQUIPMENT_CATEGORY = 'API_UPDATE_EQUIPMENT_CATEGORY';

const API_LOAD_EQUIPMENT_CATEGORIES_FAILED = 'API_LOAD_EQUIPMENT_CATEGORIES_FAILED';
const API_LOAD_EQUIPMENT_CATEGORIES_LOADING = 'API_LOAD_EQUIPMENT_CATEGORIES_LOADING';
const API_LOAD_EQUIPMENT_CATEGORIES_LOADED = 'API_LOAD_EQUIPMENT_CATEGORIES_LOADED';
const API_REMOVE_EQUIPMENT_CATEGORY_FAILED = 'API_REMOVE_EQUIPMENT_CATEGORY_FAILED';
const API_REMOVE_EQUIPMENT_CATEGORY_LOADING = 'API_REMOVE_EQUIPMENT_CATEGORY_LOADING';
const API_REMOVE_EQUIPMENT_CATEGORY_SUCCESS = 'API_REMOVE_EQUIPMENT_CATEGORY_SUCCESS';
const API_CREATE_EQUIPMENT_CATEGORY_FAILED = 'API_CREATE_EQUIPMENT_CATEGORY_FAILED';
const API_CREATE_EQUIPMENT_CATEGORY_LOADING = 'API_CREATE_EQUIPMENT_CATEGORY_LOADING';
const API_CREATE_EQUIPMENT_CATEGORY_SUCCESS = 'API_CREATE_EQUIPMENT_CATEGORY_SUCCESS';
const API_UPDATE_EQUIPMENT_CATEGORY_FAILED = 'API_UPDATE_EQUIPMENT_CATEGORY_FAILED';
const API_UPDATE_EQUIPMENT_CATEGORY_LOADING = 'API_UPDATE_EQUIPMENT_CATEGORY_LOADING';
const API_UPDATE_EQUIPMENT_CATEGORY_SUCCESS = 'API_UPDATE_EQUIPMENT_CATEGORY_SUCCESS';

const defaultState = { equipmentCategories: [], loading: false };
const emptyCostCode = () => ({ id: getId(), name: '', isRemoving: false });
const mapDefaults = equipment => ({ ...emptyCostCode(), ...equipment });

export const reducer = (state = defaultState, { type, response, id, replaceId, resource }) => {
  switch (type) {
    case API_LOAD_EQUIPMENT_CATEGORIES_LOADED:
      return update(state, {
        loading: { $set: false },
        equipmentCategories: { $set: response.map(mapDefaults) },
      });
    case API_LOAD_EQUIPMENT_CATEGORIES_LOADING:
      return update(state, { loading: { $set: true } });
    case API_LOAD_EQUIPMENT_CATEGORIES_FAILED:
      return update(state, { loading: { $set: false } });
    case ADD_LOCAL_EQUIPMENT_CATEGORY:
      return update(state, { equipmentCategories: { $push: [emptyCostCode()] } });
    case API_REMOVE_EQUIPMENT_CATEGORY_SUCCESS:
    case REMOVE_LOCAL_EQUIPMENT_CATEGORY:
      return update(state, { equipmentCategories: { $splice: [[indexById(id, state.equipmentCategories), 1]] } });
    case API_REMOVE_EQUIPMENT_CATEGORY_FAILED:
      return update(state, { equipmentCategories: { [indexById(id, state.equipmentCategories)]: { removing: { $set: false } } } });
    case API_REMOVE_EQUIPMENT_CATEGORY_LOADING:
      return update(state, { equipmentCategories: { [indexById(id, state.equipmentCategories)]: { removing: { $set: true } } } });
    case API_CREATE_EQUIPMENT_CATEGORY_FAILED:
      return update(state, { equipmentCategories: { [indexById(resource.id, state.equipmentCategories)]: { saving: { $set: false } } } });
    case API_CREATE_EQUIPMENT_CATEGORY_LOADING:
      return update(state, { equipmentCategories: { [indexById(resource.id, state.equipmentCategories)]: { saving: { $set: true } } } });
    case API_CREATE_EQUIPMENT_CATEGORY_SUCCESS:
      return update(state, { equipmentCategories: { $splice: [[indexById(replaceId, state.equipmentCategories), 1, response]] } });
    default:
      return state;
  }
};

export const equipmentCategories = state => state.equipmentCategories.equipmentCategories.sort((a, b) => naturalCompare.caseInsensitive(a.name, b.name));
export const loading = state => state.equipmentCategories.loading;

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/equipmentCategory/equipmentCategory.reducer.js